export default __webpack_public_path__ + "static/pathful-4bb52e4604a3106007766b0f8af585a3.jpg";